import { useState, useEffect, useMemo } from 'react';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';

export interface BarChartData {
  seriesData: any[];
  barNameList?: any[];
}

export default function useNewReleaseBarCharts(barData: any[], segmention: string): BarChartData {
  // 柱状图 相关配置
  // 柱状图 y轴数据
  const [seriesData, setSeriesData] = useState<any>([]);

  const getItemValue = (item: any, segmention: string) => {
    let metricDataList: any = [];
    let metricKey: string = '';
    if (segmention == 'gamalytic__pcu' || segmention == 'steamfollowers' || segmention == 'source_steam__pcu') {
      metricDataList = item.other_metric && Array.isArray(item.other_metric) ? item.other_metric : [];
      metricKey = 'metric';
    } else {
      metricDataList = item.store_rank && Array.isArray(item.store_rank) ? item.store_rank : [];
      metricKey = 'data_source';
    }
    const dataObj = metricDataList?.find((item: any) => item[metricKey] == segmention);
    return (dataObj && dataObj.value) ? dataObj.value : 0;
  }

  // 获取 seriesData
  const createSeriesData = (data: any[], segmention: string): any[] => {
    if (!Array.isArray(data)) return [];
    return data.map((item: any, i: number): any => ({
      type: 'bar',
      name: item.name,
      value: getItemValue(item, segmention),
      cover: item.cover,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
      }
    }));
  };

  useEffect(() => {
    setSeriesData(createSeriesData(barData, segmention));
  }, [barData, segmention]);

  const barNameList = useMemo(() => {
    return barData?.map((item: any, i: number): any => (item.name));
  }, [barData]);

  return {
    seriesData,
    barNameList,
  };
}
